<div class="modal-overlay" (click)="closeOnBackdrop && onClose()"></div>
<div class="modal" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
  <section class="modal__body">
    <ng-content></ng-content>
  </section>
  <footer class="modal__footer">
    <ng-content select="[modal-footer]"></ng-content>
  </footer>
</div>